import React, { useState } from 'react';
import { ProductApi } from 'common/types';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import ProductRow from 'components/ProductRow';
import ProductReorderDialog from 'components/ProductReorderDialog';

import { useSelector } from 'react-redux';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { RiArrowUpDownLine } from 'react-icons/ri';
import { useTranslation } from 'services/localization';

interface Props {
	products: ProductApi[];
	label: string;
	enableReorder?: boolean;
}
const ProductGroup = (props: Props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const [isReordering, setIsReordering] = useState<boolean>(false);

	const shopCurrency = useSelector(ShopSelectors.getShopCurrency);

	return (
		<Box>
			<Box className={classes.header}>
				<Typography variant="h6" gutterBottom className={classes.label}>
					{props.label}
				</Typography>
				{props.enableReorder && (
					<Box ml={2}>
						<Tooltip title={t('common:actions.changeOrder')}>
							<IconButton onClick={() => setIsReordering(true)} size="large">
								<RiArrowUpDownLine />
							</IconButton>
						</Tooltip>
					</Box>
				)}
			</Box>
			<Box>
				{props.products.map((product) => {
					return <ProductRow key={product.id} product={product} currency={shopCurrency} />;
				})}
			</Box>
			<ProductReorderDialog
				open={isReordering}
				onClose={() => setIsReordering(false)}
				products={props.products}
			/>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		header: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		label: {
			color: theme.palette.colors.tundra.main,
			fontSize: 18,
		},
	}),
);

export default ProductGroup;
